import {
    createFileRoute,
    ErrorComponent,
    Link,
    Outlet,
    useRouter,
} from '@tanstack/react-router'

import { NoPermissionError } from '@/api/NoPermissionError'
import { NoPermissionErrorComponent } from '@/components/NoPermissionErrorComponent'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { Grid, Tooltip } from '@mui/material'
import { useSuspenseQuery } from '@tanstack/react-query'
import { membershipQueryOptions } from '../../api/membershipQueryOptions'

export const Route = createFileRoute(
    '/_auth/membership_/$membershipUuid'
)({
    component: MembershipComponent,
    errorComponent: ({ error }) => {
        if (error instanceof NoPermissionError) {
            return (
                <NoPermissionErrorComponent error={error}></NoPermissionErrorComponent>
            )
        }
        return <ErrorComponent error={error}></ErrorComponent>
    },
})

function MembershipComponent() {
    const params = Route.useParams()
    const membershipQuery = useSuspenseQuery(
        membershipQueryOptions(params.membershipUuid),
    )
    const membership = membershipQuery.data

    const router = useRouter()
    const state = router.history.location.state

    return (
        <Grid container spacing={1} sx={{ px: 1 }}>
            <Grid size={11}>
                <Grid container spacing={1}>
                    <Grid size={1}>
                        <Link
                            to={state.route}
                            search={{
                                filter: state.filter,
                                sort: state.sort,
                                visibility: state.additional,
                            }}
                        >
                            <Tooltip title="Zurück zur Übersicht">
                                <ArrowBackIosNewIcon />
                            </Tooltip>
                        </Link>
                    </Grid>
                    <Grid size={11}>
                        <span>
                            {membership.uuid} {membership.member.scoutId}
                        </span>
                    </Grid>
                </Grid>
                <Outlet />
            </Grid>
            <Grid size={1} sx={{
                maxWidth: 50
            }}></Grid>
        </Grid>
    );
}
